/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Security_Secure_Account_LabelInputs */

const en_security_secure_account_label = /** @type {(inputs: Security_Secure_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure your account:`)
};

const es_security_secure_account_label = /** @type {(inputs: Security_Secure_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protege tu cuenta:`)
};

/**
* | output |
* | --- |
* | "Secure your account:" |
*
* @param {Security_Secure_Account_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const security_secure_account_label = /** @type {((inputs?: Security_Secure_Account_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Security_Secure_Account_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_security_secure_account_label(inputs)
	return es_security_secure_account_label(inputs)
});